






























































































































































import { Component, Vue } from 'vue-property-decorator'
import { Select, Option, Icon } from 'view-design'
import { getPricingData } from '@/api/modules/pricing'
import 'view-design/dist/styles/iview.css'
import { ISegmentList } from '@/api/modules/types'
import { CoupeSDK } from '@xl/coupe-sdk'
const environment =
  process.env.NODE_ENV === 'development'
    ? 'stg'
    : document.documentElement.dataset.vanEnv || 'prd'
// 实例化 sdk
const sdk = new CoupeSDK({
  coupeId: '804ce510ec0d40b19133092a4bed0a62',
  env: environment
})
@Component({
  name: 'Pricing',
  components: {
    Select,
    Option,
    Icon
  },
  filters: {
    fixedLongDistanceRule(v: ISegmentList) {
      if (!v) return
      return +v.end === 99999000
        ? `超出${+v.begin / 1000}公里`
        : `${+v.begin / 1000} - ${+v.end / 1000}公里`
    },
    fixedPrice(v: number) {
      if (!v) return '0.00'
      return (v / 100).toFixed(2)
    },
    fixedRowSpan(v: ISegmentList[]) {
      if (!v) return
      return v.length > 0 ? v.length + 2 : 2
    }
  }
})
export default class extends Vue {
    private pricingMap = {
      startDistance: '',
      startTimeLen: '',
      startPriceRule: {
        defaultPrice: '',
        segmentList: []
      },
      exceedDistanceRule: {
        defaultPrice: '',
        segmentList: []
      },
      exceedTimeLenRule: {
        defaultPrice: '',
        segmentList: []
      },
      longDistanceRule: {
        defaultPrice: '',
        defaultConfig: [],
        segmentList: []
      }
    }

    private cityId = ''
    private cityIdMap = {}

    async created() {
      // 调用 fetch 获取数据
      const data = await sdk.fetch() as { potalCityList: string }
      if (data.potalCityList) {
        this.cityIdMap = JSON.parse(data.potalCityList)
        this.cityId = Object.keys(this.cityIdMap)[0]
      }
      await this.fetchData()
    }

    private get longSegmentListLength() {
      return this.pricingMap.longDistanceRule.segmentList.reduce((a, b :any) => {
        return a + b.segmentPrice.length
      }, this.pricingMap.longDistanceRule.segmentList.length + 2)
    }

    private get allLength() {
      return this.pricingMap.longDistanceRule.defaultConfig.length + this.longSegmentListLength
    }

    private async fetchData() {
      const { data } = await getPricingData({ city_id: this.cityId })
      this.pricingMap = data
    }

    private handleChange() {
      this.fetchData()
    }
}
